import { render, staticRenderFns } from "./agv-basic-article-info-with-magnet.vue?vue&type=template&id=c7500278&scoped=true&lang=pug&"
import script from "./agv-basic-article-info-with-magnet.vue?vue&type=script&lang=js&"
export * from "./agv-basic-article-info-with-magnet.vue?vue&type=script&lang=js&"
import style0 from "./agv-basic-article-info-with-magnet.vue?vue&type=style&index=0&id=c7500278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7500278",
  null
  
)

export default component.exports